<app-modal-header
  text="{{ 'TDRAW.MODAL.PINPOINT_IMAGE.TITLE' | translate }}"
  (closeAction)="onClose()"
></app-modal-header>
<div class="body">
  <img [src]="imageUrl" />
</div>
